import React from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/'); };

  const navItems = [
    { to: '/admin', label: '대시보드', icon: '📊' },
    { to: '/admin/group-buys', label: '한정판매 관리', icon: '🛍️' },
    { to: '/admin/products', label: '상품 관리', icon: '📦' },
    { to: '/admin/categories', label: '카테고리 관리', icon: '🗂' },
    { to: '/admin/banner', label: '배너 관리', icon: '🖼' },
    { to: '/admin/site-events', label: '이벤트 관리', icon: '🎉' },
    { to: '/admin/orders', label: '주문 관리', icon: '📋' },
    { to: '/admin/purchase-requests', label: '대리구매 신청', icon: '📝' },
    { to: '/admin/users', label: '회원 관리', icon: '👥' },
    { to: '/admin/coupons', label: '쿠폰 관리', icon: '🎟' },
  ];

  return (
    <div style={styles.layout}>
      <aside style={styles.sidebar}>
        <div style={styles.logo}>
          <Link to="/" style={styles.logoText}><img src="/logo.png" alt="Moa" style={styles.logoImg} /></Link>
          <p style={styles.adminLabel}>관리자</p>
        </div>
        <nav style={styles.nav}>
          {navItems.map(item => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                style={{ ...styles.navItem, ...(active ? styles.navActive : {}) }}
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div style={styles.sideBottom}>
          <p style={styles.adminName}>{user?.name}</p>
          <button onClick={handleLogout} style={styles.logoutBtn}>로그아웃</button>
        </div>
      </aside>

      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  layout: { display: 'flex', minHeight: '100vh' },
  sidebar: {
    width: 220, background: '#1a1a2e', display: 'flex', flexDirection: 'column',
    position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 10,
  },
  logo: { padding: '24px 20px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  logoText: { color: '#b39ddb', fontSize: 16, fontWeight: 700 },
  logoImg: { height: 34, display: 'block' },
  adminLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 11, marginTop: 4 },
  nav: { flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 4 },
  navItem: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 12px', borderRadius: 8, color: 'rgba(255,255,255,0.6)',
    fontSize: 13, fontWeight: 500, transition: 'all 0.15s',
  },
  navActive: { background: 'rgba(179,157,219,0.2)', color: '#b39ddb' },
  sideBottom: { padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' },
  adminName: { color: 'rgba(255,255,255,0.7)', fontSize: 13, marginBottom: 8 },
  logoutBtn: { background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: 12, cursor: 'pointer', padding: 0 },
  main: { marginLeft: 220, flex: 1, padding: 32, background: '#f8f8f8', minHeight: '100vh' },
};

export default AdminLayout;
